module.exports = new Promise(resolve => {
        const remoteUrlWithVersion = window.BeekeeperCdn + '/tasks/__bundles/webComponentsRemoteEntry.js';

        const script = document.createElement('script');
        script.src = remoteUrlWithVersion;
        script.onload = () => {
            const proxy = {
                get: (request) => window.BeekeeperTasksWebComponents.get(request),
                init: (...arg) => {
                    try {
                        return window.BeekeeperTasksWebComponents.init(...arg);
                    } catch(e) {
                        console.error('remote container already for BeekeeperTasksWebComponents already initialized');
                    }
                }
            }

            resolve(proxy);
        }

        // Failure Handler
        script.onerror = () => {
            console.error('Failed to load remote: BeekeeperTasksWebComponents at ' + remoteUrlWithVersion);
            
            // Resolve with a "Null Object" pattern so the host doesn't crash
            const fallbackProxy = {
                get: (request) => {
                    // Return a function that returns a component or module
                    // This allows the host's to still "resolve"
                    return Promise.resolve(() => ({
                        default: () => null
                    }));
                },
                init: () => {}
            };
            resolve(fallbackProxy);
        };

        document.head.appendChild(script);
    })
    ;